import { Component, OnInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { GridService } from 'app/Shared/Services/grid.service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UserService } from 'app/Shared/Services/user.service';
import { CommonModule, DatePipe, LowerCasePipe, NgClass } from '@angular/common';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { Exceptions } from './common-grid.model';
import { CommonGridService } from './common-grid.service';
import { ActivatedRoute } from '@angular/router';
import { ExceptionDetailsService } from '../exception-details/exception-details.service';
import { Table, TableModule  } from "primeng/table";
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { SymbolPanelComponent } from 'app/Shared/Component/symbol-panel/symbol-panel.component';
import { ExceptionDetailsComponent } from '../exception-details/exception-details.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ExceptionCommentComponent } from 'app/Shared/Component/exception-comment/exception-comment.component';
import { ToastModule } from 'primeng/toast';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-common-grid',
    imports: [TableModule, CommonModule, SymbolPanelComponent, FilterPanelComponent, MatProgressSpinner, NgClass, ExceptionDetailsComponent,
        LowerCasePipe, MatTooltipModule, ButtonModule, ExceptionCommentComponent, ToastModule, MatInputModule,
        MatFormFieldModule],
    providers: [CommonGridService],
    templateUrl: './common-grid.component.html',
    styleUrls: ['./common-grid.component.scss']
})
export class CommonGridComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table;
  @Input() GridColumns: any;
  @Input() exceptionCode: any;
  @Input() pageName: any;
  dataset: any[] = [];
  selectedRow: Exceptions[] = [];
  selectedRowDetail: any;
  isLoadingResults: boolean = true;
  tbldatamsg: string = "L o a d i n g . . . . .";
  totalRecords!: number;
  Limit: any = { 'Start': '', 'End': '' };
  defaultFilterArray: any = [];
  startLimit: any = 0;
  endLimit!: number;
  rowcount!: number;
  columnJson: any = [];
  cols: any = []
  activityDetails: Array<any>= [];
  priviousStartLimit: any;
  pageNumber: any = 1;
  isShowGraph: boolean = false;
  FromDate: any = "";
  SymbolsArray: any = [];
  CodesArray: any = [];
  userList : any = [];
  defaultOptedExceptionCodes: any = [];
  exceptionCodesArray: any = [];
  isResetGridlimit: boolean = false;
  ActiveSymbol: any;
  ResetLabel!: string;
  isShowExceptionDetails: boolean =false;
  isFilterLabelReset: boolean = false;
  LastClientReportDate: any;
  ExceptionCode!: string | null;
  LastExecutionCATDate: any;
  isDisplayCommentDialog: boolean = false;
  
  constructor(private gridService: GridService,
    private activatedRoute: ActivatedRoute,
    public constantService: ConstantService,
    private sharedHttpClientService: SharedHttpClientService,
    private emitterService: EmitterService,
    private urlsService: UrlsService,
    private userService: UserService,
    public commonGridService: CommonGridService,
    public exceptionDetailsService: ExceptionDetailsService,
    private messageService:MessageService,
    private confirmationService: ConfirmationService,
    private changeDetectorReference: ChangeDetectorRef
) {
  }

  ngOnInit() {
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimit = this.rowcount;
    this.Limit = { 'Start': '0', 'End': '15' };
    this.totalRecords = this.rowcount;   
    this.FromDate = this.activatedRoute.snapshot.paramMap.get('Date');
    this.ExceptionCode = this.activatedRoute.snapshot.paramMap.get('Code');
    /*** Get Last CAT Execution date*/
    let todate: any;
    todate = this.userService.getDatesForClientData()[0];
    this.LastExecutionCATDate = [];
    if (todate != "" || todate != undefined || todate != null) {
      this.LastExecutionCATDate[0] = (todate);// Fromdate
      this.LastExecutionCATDate[1] = (todate);// Todate
      this.defaultFilter();
    }
    this.getExceptionCodes();
    this.getColumns();
    this.getData();
    this.getSymbols();
    /* Retrieve List of Users */
    this.exceptionDetailsService.getUserList()
    .subscribe({
      next: (data:any) => {
      this.userList = data.Data;
      this.userList.unshift({label: 'Select User', value: ''});
    }});
  }
 
  ngAfterContentChecked() {
    this.changeDetectorReference.detectChanges();
  }

  setActiveSymbolEvent(event: any) {
    this.ActiveSymbol = event;
    for (let i = 0; i < this.defaultFilterArray.length; i++) {
      if (this.defaultFilterArray[i].label.toLocaleLowerCase() == 'symbol') {
        this.defaultFilterArray[i].values = this.ActiveSymbol;
        this.startLimit = 0;
        this.Limit.Start = 0;
        this.totalRecords = 0;
        this.pageNumber = 1;
        this.dt.first = this.startLimit;
        this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
        this.getData();
      }
    }
  }
  getSymbols() {
    this.SymbolsArray = [];
    this.CodesArray = [];
    this.isResetGridlimit = true;
    this.commonGridService.getSymbol({
      mpid: this.userService.getActiveMPID(),
      exceptionType: this.exceptionCode,
      startLimit: this.Limit.Start,
      endLimit: this.Limit.End,
      data: this.defaultFilterArray
    })
      .subscribe({
        next: (Element:any) => {
        this.SymbolsArray = [];
        this.CodesArray = [];
        let Filter: any = Element;
        this.SymbolsArray = Filter.SymbolList;
        this.CodesArray = Filter.CodeList;
      }, error: (err: HttpErrorResponse) => {
      }});
  }
  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
    }
  }
  changePage(event: any) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

  getData() {
    this.isLoadingResults = true;
    this.tbldatamsg = "L o a d i n g . . . . .";

    /* Logic for Reset Exception Codes when cancel filter event of Exception Type triggered */
    let exceptionTypeFieldIndex = this.defaultFilterArray.findIndex((item: { columnname: string; }) => item.columnname === "Exception_Description");
    if(exceptionTypeFieldIndex != -1) {
      let exceptionTypeField = this.defaultFilterArray.filter((item: { columnname: string; }) => item.columnname === "Exception_Description");
      this.defaultFilterArray[exceptionTypeFieldIndex].values = (exceptionTypeField[0].values.length <= 0 ? this.defaultOptedExceptionCodes : this.defaultFilterArray[exceptionTypeFieldIndex].values);
    }

    this.commonGridService.getData({
      mpid: this.userService.getActiveMPID(),
      exceptionType: this.exceptionCode,
      startLimit: this.Limit.Start,
      endLimit: this.Limit.End,
      data: this.defaultFilterArray
    }).subscribe({
      next: (response:any) => {
      if (response) {
        this.isLoadingResults = false;
        if(response.Data) {
          this.dataset = response.Data;
        } else {
          this.dataset = [];
        }
       
        this.totalRecords = response.totalCount;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        this.isResetGridlimit = false;
        this.isFilterLabelReset = false;
      }
    }})
  }
  openOrderViewer(rowData: any) {
    
  }
  FilterEventClearSymbol(event: any) {
    this.isResetGridlimit = true;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.emitterService.ResetQuickFilterPanelEvent.emit("Symbol");
  }

  async getExceptionCodes() {
    return await this.commonGridService.getExceptionCodes({
      exceptionGroupId: this.exceptionCode
    }).subscribe({
      next: (Element:any) => {
        let response: any = Element;
        this.exceptionCodesArray = response.exceptionCodes;
        this.defaultOptedExceptionCodes = this.exceptionCodesArray.map((codes: { label: any; }) => codes.label);
        this.defaultFilter();
      }, error: (err: HttpErrorResponse) => {}
    });
  }

  defaultFilter() {
    let todate = this.userService.getDatesForClientData()[0];
    let fromdate =new Date(this.userService.getDatesForClientData()[1].setFullYear(new Date().getFullYear() - 1)) ;
    if (this.FromDate == ('Null')) {
      todate = this.userService.getDatesForClientData()[0];
      fromdate  = new Date(this.userService.getDatesForClientData()[1].setFullYear(new Date().getFullYear() - 1));
      fromdate.setDate(todate.getDate()-30);
      this.LastExecutionCATDate = [];
      this.LastExecutionCATDate.push(fromdate);// Fromdate
      this.LastExecutionCATDate.push(todate);// todate
      if (this.ExceptionCode == '0012')
        this.ExceptionCode = '';
    } else if (this.FromDate) {
      this.LastExecutionCATDate = [];
      this.LastExecutionCATDate.push(this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(new Date(new Date(this.FromDate).setFullYear(new Date(this.FromDate).getFullYear() - 1))))); // FromDate
      this.LastExecutionCATDate.push(this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.FromDate))); // Todate
    }

    this.defaultFilterArray = [
      {
        "isdefault": "true",
        "label": "Date",
        "columnname": "reportDate",
        "filterby": "IS",
        "values": this.LastExecutionCATDate,
        "time": " ",
        'datatype': 'DateRange',
        'disabled': 'true',
        "dropdown": "",
        "dropdownvalue": ""
      },
      {
        "isdefault": "true",
        "label": "Exception Type",
        "columnname": "Exception_Description",
        "filterby": "IN",
        "values": this.defaultOptedExceptionCodes,
        "time": "",
        "datatype": "Array",
        "disabled": "true",
        "dropdown": "yes",
        "dropdowntype": "multiselect",
        "dropdownvalue": this.exceptionCodesArray
      },
      {
        "isdefault": "true",
        "label": "Status",
        "columnname": "Status",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": "true",
        "dropdown": "",
        "dropdownvalue": ""
      },
      {
        'isdefault': 'true',
        'label': 'Symbol',
        'columnname': 'symbol',
        'filterby': 'IS',
        'values': '',
        'time': '',
        'datatype': 'String',
        'disabled': 'true',
        'dropdown': '',
        'dropdownvalue': ''
      },
    ]
  }

  filterApplyFilterEvent(event: any) {
    this.isResetGridlimit = true;
    this.defaultFilterArray = [];
    this.defaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.getSymbols();
    this.getData();
  }

  openDialog(rowData: Exceptions[]) {
    this.selectedRow = rowData;
    this.isShowGraph = true;
  }
  openExceptionDetails(rowData: Exceptions) {
    this.selectedRow = [];
    this.selectedRow.push(rowData);
    this.selectedRowDetail = rowData;
    this.isShowExceptionDetails = true;
  }
  addComment(rowData: Exceptions) {
    let searchExceptionItem = (this.selectedRow.length > 0) ? this.selectedRow.filter((selectedRowDetail) => selectedRowDetail.OrderExceptionID === rowData.OrderExceptionID) : [];

    if ((this.selectedRow.length === 0) || (this.selectedRow.length > 0 && searchExceptionItem.length === 0)) {
      this.selectedRow = [];
      this.selectedRow.push(rowData);
    }
    this.isDisplayCommentDialog = true;
  }
  updateClientDataStaus(event: any) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to Update the status/comment of selected records ?',
      key: 'informationDialog',
      accept: () => {
        this.isLoadingResults = true;
        this.tbldatamsg = "L o a d i n g . . . . .";
        if(event.selectedRow.length) {
          let selectedUserName = this.userList.filter((user: { value: any; }) => user.value===event.selectedUser);
          for(let i=0; i<event.selectedRow.length; i++) {
            this.exceptionDetailsService.updateClientDataExceptionStatus({
              exceptionId: event.selectedRow[i].OrderExceptionID,
              status: event.selectedStatus,
              owner: selectedUserName[0].label.toUpperCase(),
              comment: event.commentStatement,
              updatedBy: this.userService.getUserName()
            }).subscribe({
              next: (result:any) => {
              if((i === event.selectedRow.length - 1)) {
                this.getData();
                this.isLoadingResults = true;
              }
            }});
          }
          this.isDisplayCommentDialog = false;
          this.selectedRow = [];

          this.messageService.clear();
          this.messageService.add({ severity: 'success', summary: 'success', detail: 'Comments added successfully' });
        }
      }
    });
  }
 

}